'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';

/** Ctrl K, or ⌘ K on a Mac: the key sites use to open their search. */
const isSearchShortcut = (event: KeyboardEvent): boolean => event.key.toLowerCase() === 'k' && (event.ctrlKey || event.metaKey) && !event.altKey;

/** Calls `onOpen` when the search shortcut is pressed anywhere on the page. */
export const useSearchShortcut = onOpen => {
  const $ = _c(3);
  let t0;
  let t1;
  if ($[0] !== onOpen) {
    t0 = () => {
      const handleKeyDown = event => {
        if (!isSearchShortcut(event)) {
          return;
        }
        event.preventDefault();
        onOpen();
      };
      globalThis.addEventListener("keydown", handleKeyDown);
      return () => globalThis.removeEventListener("keydown", handleKeyDown);
    };
    t1 = [onOpen];
    $[0] = onOpen;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
};